import { render, staticRenderFns } from "./PrimaryMobile.vue?vue&type=template&id=2baa1340&"
import script from "./PrimaryMobile.vue?vue&type=script&lang=js&"
export * from "./PrimaryMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports